




































































































import {Vue, Component, PropSync, Prop} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import claimStatusTypes from '@/const/words/claimStatusTypes_multilang';
import {ClaimType} from '@/types/claim';

@Component({
  components: {
    CompSelectBox
  }
})
export default class ClaimStatusCheckList extends Vue{
  private refundsStatusTypes: any[] = [
    {value: 'REQUEST', name: 'ORDER_ORDER_CONTENT_TOP_REFUNDS_TYPE_REQUEST'},
    {value: 'WAITING', name: 'ORDER_ORDER_CONTENT_TOP_REFUNDS_TYPE_WAITING'},
    {value: 'ADJUST_REQUESTED', name: 'ORDER_ORDER_CONTENT_TOP_RETURN_REFUND_AMT_ADJUST_REQUESTED'},
    {value: 'DONE', name: 'ORDER_ORDER_CONTENT_TOP_REFUNDS_TYPE_DONE'},
  ];

  @Prop({required: true})
  private readonly searchFormType!: ClaimType

  @PropSync('claimStatusTypes')
  private claimStatusTypesSync!: string[]

  private isClaimStatusCheckAll = false;
  private showHelpDetail = false;
  private claimStatusTypeCheckList = []

  //TODO: 네이밍
  private isAllChecked(): void{
    this.$nextTick(()=>{
      this.isClaimStatusCheckAll = this.claimStatusTypesSync.length === this.claimStatusTypeCheckList.length
    })
  }

  private checkAll(): void{
    this.isClaimStatusCheckAll = !this.isClaimStatusCheckAll
    if(this.isClaimStatusCheckAll){
      this.claimStatusTypesSync = this.claimStatusTypeCheckList.map(claimStatus => claimStatus.value)
      return
    }

    this.claimStatusTypesSync = []
  }

  private setClaimStatusCheckList(){
    if(this.searchFormType === 'REFUND'){
      this.claimStatusTypeCheckList = [...this.refundsStatusTypes]
      return
    }
    this.claimStatusTypeCheckList = claimStatusTypes.filter(claimStatusType => claimStatusType.value.includes(this.searchFormType))
  }

  public reset(){
    this.isClaimStatusCheckAll = false;

    if(!this.$route.query.fromMain){
      this.checkAll();
    }
  }

  private created(){
    this.setClaimStatusCheckList();
    this.reset()
  }
}
